import { render, staticRenderFns } from "./checkout-payment-box.vue?vue&type=template&id=6ce809bc&scoped=true"
import script from "./checkout-payment-box.vue?vue&type=script&lang=js"
export * from "./checkout-payment-box.vue?vue&type=script&lang=js"
import style0 from "./checkout-payment-box.vue?vue&type=style&index=0&id=6ce809bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce809bc",
  null
  
)

export default component.exports